import { type DeviceDetails } from '@service-initiation/tech-care-data-access-store';

export const completedDeviceDetails = (
  deviceDetails?: DeviceDetails
): boolean => {
  if (!deviceDetails) return false;
  if (!deviceDetails?.isBottomLevel) return false;

  if (deviceDetails.isEligibleForColorOptions && !deviceDetails.colorOptions) {
    return false;
  }

  if (
    deviceDetails.isEligibleForColorOptions &&
    deviceDetails.colorOptions &&
    deviceDetails.colorOptions?.length > 0 &&
    deviceDetails.selectedDeviceColorOption === undefined
  ) {
    return false;
  }

  return true;
};
